import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Nav } from "react-bootstrap";
import { FaCalendarCheck } from "react-icons/fa";
import { SiApplemusic } from "react-icons/si";
import { BsFillShieldLockFill } from "react-icons/bs";
import { TbClubsFilled } from "react-icons/tb";
import { BiSolidCalendarEvent } from "react-icons/bi";
import { FaSquarePollHorizontal } from "react-icons/fa6";
import { LuPen } from "react-icons/lu";
import { RiDeleteBack2Line } from "react-icons/ri";
import CreatePost from "../../components/CreatePost";
import PostList from "../../components/Post";
import CreateEvent from "../../components/CreateEvent";
import MemberList from "../../components/ClubMembers";
import { useAuth } from "../../context/AuthContext";
import CreateClubModal from "../../components/CreateClubModal"; // Import modal

import c1 from "../../assets/images/club-list1.svg";
import c2 from "../../assets/images/c2.svg";
import c3 from "../../assets/images/c3.svg";

// Dummy club data
const clubs = [
  {
    id: 1,
    username: "Pulp Music Club",
    profilePic: c1,
    description: "Pulp, the cocktail bar at The Park, Kolkata epitomizes the glamour and the style of the 60s.",
    date: "2025-02-04",
    category: "Rock Music",
    privacy: "Public",
    members: "12.4k",
    posts: "860",
    polls: "4",
    events: "3",
  },
  {
    id: 2,
    username: "Rock Music Club",
    profilePic: c2,
    description: "A club for rock music lovers, sharing the best tracks and events!",
    date: "2025-03-15",
    category: "Music",
    privacy: "Private",
    members: "12.4k",
    posts: "860",
    polls: "4",
    events: "3",
  },
  {
    id: 3,
    username: "Pizza Lovers",
    profilePic: c3,
    description: "Best place for pizza lovers. Share your favorite recipes and restaurants.",
    date: "2025-04-10",
    category: "Food & Drinks",
    privacy: "Public",
    members: "12.4k",
    posts: "860",
    polls: "4",
    events: "3",
  },
];


function MyClubs() {
  // const [modalShow, setModalShow] = React.useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { isAuthenticated } = useAuth();
  const [selectedClub, setSelectedClub] = useState(clubs[0]); // Show first club on load
  const [activeTab, setActiveTab] = useState("option1"); // Default tab
 
  return (
    <Container fluid className="my-clubs-page">
      <h2 className="mb-20">My Clubs</h2>
      <Row>
        {/* Sidebar */}
        <Col md={5} lg={4} >
          <div className="sidebar-my-club">
            <div className="create-club-btn-wraper">
              <Button variant="outline-primary" className="create-club-btn" onClick={() => setModalShow(true)}>
                Create a Club
              </Button>
              <CreateClubModal show={modalShow} onHide={() => setModalShow(false)} />
            </div>
            <div className="club-list">
              {clubs.map((club) => (
                <div
                  key={club.id}
                  className={`club-item ${selectedClub.id === club.id ? "active" : ""}`}
                  onClick={() => setSelectedClub(club)}
                >
                  <img src={club.profilePic} alt={club.username} className="club-icon" />
                  <div className="club-info">
                    <h5>{club.username}</h5>
                    <p>{club.members} members</p>
                    <p>
                      <FaSquarePollHorizontal />
                      {club.posts} Posts & {club.polls} Polls
                    </p>
                    {club.events > 0 && (
                      <p>
                        <BiSolidCalendarEvent /> {club.events} Active event{club.events > 1 ? "s" : ""}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Col>

        {/* Club Details Section */}
        <Col md={7} lg={8} className="my-club-details">
          {selectedClub && (
            <Card className="club-details-card">
              <Card.Body className="d-flex">
                {/* Club Image */}
                <div className="club-logo">
                  <img src={selectedClub.profilePic} alt={selectedClub.username} className="club-image" />
                </div>

                {/* Club Info */}
                <div className="club-info">
                  <div className="club-header">
                    <h4 className="club-name">{selectedClub.username}</h4>

                    <div className="menu-container">
                      <button disabled={!isAuthenticated} className="menu-button" onClick={() => setMenuOpen(!menuOpen)}>
                        ⋮
                      </button>
                      {menuOpen && (
                        <div className="menu-dropdown">
                          <div className="menu-item">
                            <LuPen /> Edit
                          </div>
                          <div className="menu-item delete">
                            <RiDeleteBack2Line /> Deactivated
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <p className="club-description">{selectedClub.description}</p>

                  <div className="club-meta-wraper">
                    {/* Club Meta Info */}
                    <div className="club-meta">
                      <span>
                        <FaCalendarCheck />{" "}
                        {new Date(selectedClub.date).toLocaleDateString("en-US", {
                          month: "short",
                          day: "2-digit",
                          year: "numeric",
                        })}
                      </span>
                      <span><SiApplemusic /> {selectedClub.category}</span>
                      <span><BsFillShieldLockFill /> {selectedClub.privacy}</span>
                    </div>

                    {/* Join Club Button */}
                    {isAuthenticated && (
                      <Button variant="outline-primary" className="join-btn">
                        <TbClubsFilled /> Join Club
                      </Button>
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          )}

          {/* Navigation Tabs */}
          <Nav variant="pills" activeKey={activeTab} onSelect={(selectedKey) => setActiveTab(selectedKey)}>
            <Nav.Item>
              <Nav.Link eventKey="option1">Posts & Polls</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="option2">Members</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="option3">Events</Nav.Link>
            </Nav.Item>
          </Nav>

          {/* Tab Content */}
          <div className="tab-content mt-3">
            {activeTab === "option1" && <div>
              <CreatePost />
              <PostList filterByUser="Rose Winslet" filterByType={["post", "poll"]} />
            </div>}
            {activeTab === "option2" && <div>
              <MemberList />
            </div>}
            {activeTab === "option3" && <div>
              <CreateEvent />
              <PostList filterByEventCreate="Rose Winslet" filterByType="event" />
            </div>}
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default MyClubs;
